module.exports = __webpack_public_path__ + "static/media/img_fenlei07.77ce2aa7.png";